<template>
  <el-dialog
    :title="title"
    :visible.sync="showAddEvaluation"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="dialog-main-content">
      <div> 
        <el-form ref="searchForm" :model="listQuery">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="keyword">
                <el-input
                  v-model="listQuery.keyword"
                  size="small"
                  clearable
                  placeholder="请输入测评名称"
                />
              </el-form-item>
            </el-col>


            <el-col :span="8">
              <div class="search-btns">
                <el-button size="small" @click="handleReset">重置</el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="handleSearch(1)"
                  class="btn-bg"
                  style="margin-left: 20px;"
                  >搜索</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div class="main-content-list">
          <el-table
            :data="questionnaireList"
            :header-cell-style="{
              textAlign: 'center',
              color: '#333333',
              fontSize: '14px',
              fontWeight: 'bold',
              backgroundColor: '#FAFAFA',
            }"
            height="540"
            tooltip-effect="dark"
            ref="multipleTable"
            fit
            highlight-current-row
          >
            
            <el-table-column
              align="center"
              prop="name"
              label="测评类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="examPaperName"
              label="问卷名称"
            ></el-table-column>
            <el-table-column align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="handleLook(scope.row)"
                  >预览</el-button
                >
                
                <el-button
                  
                  type="text"
                  size="medium"
                  @click="handleAdd(scope.row)"
                  >选用</el-button
                >
              </template>
            </el-table-column>
            <!-- 仅平台有 -->
            <template slot="empty" v-if="showCompanyBtn && $store.state.userPlatForm === 'platForm' && hospitalId && hospitalId !== 'null' && defaultIdType === 'hospitalId'">
              <div>
                <div>对应机构暂无数据，是否去平台查找</div>
                <el-button type="primary" @click="companySearch(1)">搜平台</el-button>
              </div>
            </template>
            <template slot="empty" v-if="defaultIdType === 'companyId' && !questionnaireList.length">
              <!-- 仅平台有 -->
              <div>
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
        <el-pagination
          background
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- 预览测评 -->
      <previewEvaluation
        v-if="showQuestion"
        :showQuestion.sync="showQuestion"
        :typeFormDatas="typeFormData"
      />
    </div>
  </el-dialog>
</template>
<script>
import previewEvaluation from "./previewEvaluation";
import { questionnaireDetails } from "@/api/questionnaireManage";
import {
  // pageQuestionnaire,
  queryQuestionTypeList,
  pushExamPaperSingle
} from "@/api/questionnaireManage";
import {
  healthToolTest
} from "../api";

export default {
  props: {
    showAddEvaluation: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '选择测评'
    },
    notDisplayQuestionList: {
      type: Array,
      default: () => []
    },
    showDiffQS: {
      type: Boolean,
      default: false
    },
    showCompanyBtn: {
      type: Boolean,
      default: false
    },
    hospitalId: {
      type: String,
      default: ''
    }
  },
  components: {
    previewEvaluation,
  },
  data() {
    return {
      paperId: "",
      typeFormData: {},
      showQuestion: false,
      questionnaireList: [],
      questionTypeList: [],
      listQuery: {
        
        keyword : "",
        current: 1,
        size: 10,
      },
      total: 0,
      defaultIdType: 'hospitalId'
    };
  },
  async created() {
    // await this.getInitData();
    await this.handleSearch();
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("update:showAddEvaluation", false);
    },
    handleAdd(row) {
      this.$emit("receiveEvaluation", row);
      this.$emit("update:showAddEvaluation", false);
    },
    // 获取详情
    async getPageDetail() {
      let res = await questionnaireDetails({
        id: this.paperId,
      });
      if (res.code === 0) {
        this.typeFormData = res.data;
      }
    },
    // 搜索
    async handleSearch(flag) {
      if (flag === 1) {
        this.listQuery.current = 1;
        this.listQuery.size = 10;
      }
      
      let res = await healthToolTest({
        ...this.listQuery,
        
      });
      if (res.code === 0) {
        this.questionnaireList = res.data.records;
        this.total = res.data.total;
      }
    },
    async companySearch() {
      this.defaultIdType = 'companyId'
      this.handleSearch()
    },
    // 重置
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.handleSearch();
    },
    // 查看
    async handleLook(row) {
      this.paperId = row.examPaperId;
      await this.getPageDetail();
      this.showQuestion = true;
    },
    async getInitData() {
      let { code, data } = await queryQuestionTypeList({});
      this.questionTypeList = []
      if (code == 0) {
        data.map(item => {
          if (this.showDiffQS) {
            if (item.name !== '入案评估' && item.name !== '患者服务评价') {
              this.questionTypeList.push(item)
            }
          } else {
            if (item.name !== '入案评估') {
              this.questionTypeList.push(item)
            }
          }
        })
      }
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.handleSearch();
    },
    
  },
};
</script>
<style lang="less" scoped>
// .list-question-wrap {
//   // height: 100%;
// }
/deep/.el-dialog {
  // max-width: 80%;
  // min-width: 50%;
  width: fit-content;
}
/deep/.el-dialog__body {
  padding-top: 0px;
}
/deep/.el-dialog__header {
  padding-left: 35px;
  padding-bottom: 35px;
}
.search-btns {
  margin-top: 5px;
}
.el-main {
  width: 100%;
  .main-content-list {
    // height: 62vh;
    overflow: auto;
    padding: 15px;
    padding-top: 8px;
    background-color: #fff;
  }
}
.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}
.btn-bg {
  background: #1a7bfc;
  color: #fff;
}
.dialog-main-content {
  display: flex;
}
/deep/.el-table td {
  padding: 6px 0;
}
</style>
